import './App.css';
import React from 'react';
import { Analytics } from "@vercel/analytics/react";

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Audio from './components/Audio';
import Gigs from './components/Gigs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Gigs />
        <Audio />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
